import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchSBNoLRData = createAsyncThunk(
    'SaleBillNoLRData/fetchSBNoLRData',
    async (cmpdetail, { rejectWithValue }) => {

        var requestData = CustomStringify({
            Database: cmpdetail?.Database,
            Password: cmpdetail?.Password,
            Server: cmpdetail?.Server,
            User_ID: cmpdetail?.User_ID,
            Port: cmpdetail?.Port,
        });

        try {
            const result = await POST(`/TxnSaleBill_ListWithLrno`, requestData);
            return result;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
);

const SaleBillNoLRDataSlice = createSlice({
    name: 'SaleBillNoLRData',
    initialState: {
        result: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSBNoLRData.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSBNoLRData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.result = action.payload;
            })
            .addCase(fetchSBNoLRData.rejected, (state, action) => {
                state.status = 'failed';
                state.result = [];
                state.error = action.payload;
            });
    },
});

export default SaleBillNoLRDataSlice.reducer;